const TaskItemsStrictMode = {
    FREE: 'FREE',
    NO_EXTRA: 'NO_EXTRA',
    EXACT: 'EXACT'
};

export {TaskItemsStrictMode};
